import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import NavigationBar from "components/Navigation";
import { memberService, MemberInfo } from "services/memberService";
import defaultProfileImage from "assets/MemberImage/defaultProfileImage.png";
import reservationsIcon from "assets/MypageImage/reservations.png";
import inquiryIcon from "assets/MypageImage/inquiry.png";
import reviewsIcon from "assets/MypageImage/reviews.png";
import accountIcon from "assets/MypageImage/account.png";
import {
  Container,
  ProfileSection,
  ProfileImage,
  ProfileInfo,
  ProfileName,
  ProfileDetail,
  ProfileArrow,
  MenuSection,
  MenuItem,
  MenuIcon,
  MenuText
} from "./MyPage.styles";

const MyPage: React.FC = () => {
  const isGuest = localStorage.getItem("guestMode") === "true";
  const [userInfo, setUserInfo] = useState<MemberInfo | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const data = await memberService.getMe();
        setUserInfo(data);
      } catch (error) {
        console.error("Failed to fetch user info:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserInfo();
  }, []);

  const menuItems = [
    { icon: reservationsIcon, text: "예약내역", path: "/reservations" },
    { icon: reviewsIcon, text: "리뷰 관리", path: "/reviews" },
    { icon: inquiryIcon, text: "문의하기", path: "/inquiry" },
    { icon: accountIcon, text: "계정 관리", path: "/account-management" },
  ];

  if (isLoading) {
    return (
      <>
        <Container>
          <div style={{ padding: "20px", textAlign: "center" }}>로딩 중...</div>
        </Container>
        <NavigationBar />
      </>
    );
  }

  return (
    <>
      <Container>
        <ProfileSection onClick={() => navigate(isGuest ? "/login" : "/profile")}>
          <ProfileImage>
            <img src={userInfo?.profileImage || defaultProfileImage} alt={userInfo?.name || "프로필"} />
          </ProfileImage>
          <ProfileInfo>
            <ProfileName>{isGuest ? "로그인이 필요해요" : `${userInfo?.name || "사용자"}님`}</ProfileName>
            <ProfileDetail>
              {userInfo?.university.name} {userInfo?.department}
            </ProfileDetail>
          </ProfileInfo>
          <ProfileArrow>›</ProfileArrow>
        </ProfileSection>

        <MenuSection>
          {menuItems.map((item, index) => (
            <MenuItem key={index} onClick={() => navigate(item.path)}>
              <MenuIcon>
                <img src={item.icon} alt={item.text} />
              </MenuIcon>
              <MenuText>{item.text}</MenuText>
            </MenuItem>
          ))}
        </MenuSection>
      </Container>
      <NavigationBar />
    </>
  );
};

export default MyPage;
